import { Box } from '@osmosis/tailwind-ui/components/Box';
import React, { useMemo, useState } from 'react';
import LibraryTopicBox from './LibraryTopicBox';
import LibraryTopicLevel from './LibraryTopicLevel';
import {
  MixedTopicsType,
  TypeForLevelTopic,
  TypeForTopic,
  LibraryTopic,
} from '../../types/library';

type Props = {
  topics: MixedTopicsType[];
};

type TopicLevelProps = {
  parent: TypeForLevelTopic;
  children: TypeForTopic[];
};

type LibraryTopicsWithLevelProps = {
  topic: TopicLevelProps;
};

/**
 * Library Items.
 */
const LibraryItems = (props: Props) => {
  const { topics } = props;

  const combinedTopics = useMemo(
    () =>
      topics.reduce((acc, currentTopic) => {
        if (currentTopic.block.includes('level')) {
          const currentCombinedItem = {
            children: [],
            parent: currentTopic as TypeForLevelTopic,
          };
          return [...acc, currentCombinedItem];
        }

        if (currentTopic.block.includes('videoTopicBox')) {
          if (!acc.length) return acc;
          const lastObj = acc[acc.length - 1];
          lastObj.children.push(currentTopic as TypeForTopic);
          return acc;
        }

        return acc;
      }, [] as TopicLevelProps[]),
    [topics],
  );

  return (
    <Box>
      {!!combinedTopics.length &&
        combinedTopics
          .filter((t) => !!t.children.length)
          .map((topic, index) => {
            return (
              <Box key={`topic-${index.toString()}`}>
                <LibraryTopicsWithLevel topic={topic} />
              </Box>
            );
          })}

      {!combinedTopics.length &&
        topics.length &&
        topics.map((topic) => {
          return (
            <LibraryTopicBox
              key={topic.args.hash}
              topic={topic.args as LibraryTopic}
            />
          );
        })}
    </Box>
  );
};

/**
 * Library topics with level.
 */
const LibraryTopicsWithLevel = (props: LibraryTopicsWithLevelProps) => {
  const [isTopicsOpen, setIsTopicsOPen] = useState(true);
  const { topic } = props;

  const toggleCollapseAllTopics = () => setIsTopicsOPen((prev) => !prev);

  return (
    <>
      <LibraryTopicLevel
        key={topic.parent.args.hash}
        topic={topic.parent.args}
        isTopicsOpen={isTopicsOpen}
        toggleCollapseAllTopics={toggleCollapseAllTopics}
      />

      {!!topic.children.length &&
        topic.children.map((childTopic) => (
          <LibraryTopicBox
            isTopicsOpen={isTopicsOpen}
            key={childTopic.args.hash}
            topic={childTopic.args}
          />
        ))}
    </>
  );
};

export default LibraryItems;
